var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.091671 0 0 .092722 -4.9612 -4.6834)",
    strokeWidth: 2.8698,
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m137.45 450a83.32 83.32 0 1 1 83.31-83.31 83.41 83.41 0 0 1-83.31 83.31zm0-136.63a53.32 53.32 0 1 0 53.31 53.32 53.38 53.38 0 0 0-53.31-53.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.88 395a83.32 83.32 0 1 1 83.31-83.32 83.41 83.41 0 0 1-83.31 83.32zm0-136.63a53.32 53.32 0 1 0 53.31 53.31 53.37 53.37 0 0 0-53.31-53.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.76 381.69a15 15 0 0 1-15-15v-247.39a15 15 0 0 1 11.69-14.63l237.43-53.79a15 15 0 0 1 18.31 14.63v246.17a15 15 0 0 1-30 0v-227.39l-207.43 47v235.4a15 15 0 0 1-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.75 202.62a15 15 0 0 1-3.3-29.64l237.43-53.79a15.001 15.001 0 0 1 6.63 29.26l-237.43 53.79a14.73 14.73 0 0 1-3.33 0.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.0944dca701e55674a3f7c9242a2d14ad.svg";
export { ForwardRef as ReactComponent };